import { useFeatureFlagsContext } from 'src/providers/FeatureFlagsProvider/FeatureFlags.context';
import type { tFeatureFlags } from 'src/services/FeatureFlags/FeatureFlags.types';

/**
 * True only once THIS workspace's flags have settled and the flag is on.
 *
 * For surfaces that show or hide as a whole on a rollout flag (INT-1500 U12 to
 * U15). Reads the raw flag map like `useWalletFlag` (src/pages/Wallet/hooks),
 * so nothing is added to FeatureFlagsContext's memo and nothing outside the
 * caller re-renders when a flag ships.
 *
 * `hasLoadedFeatureFlags` rather than `isLoadingFeatureFlags`: the provider
 * renders once with the defaults (or the previous workspace's map) before its
 * fetch effect raises the loading flag, and only `hasLoadedFeatureFlags` is
 * keyed by workspace. Gating on it means the surface never flashes for the
 * wrong cohort, and a failed flags fetch leaves every flag at its default
 * (off), which is today's behaviour.
 */
export function useLoadedFeatureFlag(key: keyof tFeatureFlags): boolean {
  const { featureFlags, hasLoadedFeatureFlags } = useFeatureFlagsContext();

  return hasLoadedFeatureFlags && featureFlags[key] === true;
}
